import { useState } from 'react';
import { API_BASE_URL } from '../config';
import { useNavigate, Link } from 'react-router-dom';
import { authFetch } from '../utils/auth';
import { useAuth } from '../context/AuthContext';
import './../assets/css/login.css';

function Login() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setErrorCode('');

        // Basic frontend validation
        if (!email.trim() || !password) {
            setError('Please enter both email and password.');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            setError('Please enter a valid email address.');
            return;
        }

        setLoading(true);

        try {
            const response = await authFetch(`${API_BASE_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email.trim(),
                    password: password,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.error || 'Login failed. Please try again.');
                setErrorCode(data.code || '');
                setLoading(false);
                return;
            }

            // Update Auth Context and local cache
            login({
                id: data.user_id,
                email: data.email,
                is_admin: Boolean(data.is_admin)
            }, data.token);

            // Redirect cleanly to dashboard (no user_id in URL)
            navigate('/dashboard');
        } catch (err) {
            console.error('Login error:', err);
            setError('Could not connect to the server. Please check if backend is running.');
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h1 className="login-title">Log In</h1>
                <p className="login-subtitle">Welcome back to FreeFlash</p>

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setError('');
                                setErrorCode('');
                            }}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label" htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError('');
                                setErrorCode('');
                            }}
                            required
                        />
                    </div>

                    {error && (
                        <div className="login-error" aria-live="assertive">
                            <div>{error}</div>
                            {errorCode === 'email_not_found' && (
                                <div style={{ marginTop: '8px' }}>
                                    <Link to="/get-started" className="signup-link" style={{ fontSize: '0.88rem' }}>
                                        Create an account
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}

                    <button className="login-btn" type="submit" disabled={loading}>
                        {loading ? 'Logging in...' : 'Log In'}
                    </button>
                </form>

                <div style={{ marginTop: '16px', fontSize: '13px', color: '#6b7280', textAlign: 'center' }}>
                    Forgot password? Oops.
                </div>

                <div className="signup-link-container">
                    Don't have an account?
                    <Link to="/get-started" className="signup-link">Get Started</Link>
                </div>
            </div>
        </div >
    );
}

export default Login;
